export const calculateHours = (start, end) => {
    if (!start || !end) return 0
    const s = typeof start === 'number' ? start : Date.parse(start)
    const e = typeof end === 'number' ? end : Date.parse(end)
    if (isNaN(s) || isNaN(e) || e < s) return 0
    return parseFloat(((e - s) / (1000 * 60 * 60)).toFixed(2))
}

export const calculateDays = (start, end) => {
    if (!start || !end) return 0
    const s = typeof start === 'number' ? start : Date.parse(start)
    const e = typeof end === 'number' ? end : Date.parse(end)
    if (isNaN(s) || isNaN(e) || e < s) return 0
    return parseFloat(((e - s) / (1000 * 60 * 60 * 24)).toFixed(2))
}

export const getHistoryDate = (report, type) => {
    if (!report || !type) return null
    const item = report.history?.find(h => h.type === type)
    if (!item) return null
    return Date.parse(item.timestamp || item.id)
}

export const resolveReportDate = (report, dateField, historyType) => {
    const dateFromField = Date.parse(report[dateField])
    if (!isNaN(dateFromField)) return dateFromField

    const historyDate = getHistoryDate(report, historyType)
    if (historyDate) return historyDate

    if (dateField === 'dateClose' && report.state === 'Completadas') {
        return Date.parse(report.updatedAt)
    }

    return null
}
